<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <v-btn text v-if="!orderDetail.o_is_hpc" color="warning" :to="{ name: 'ordersList' }" class="ma-0 mb-2"><v-icon left>arrow_back</v-icon> All Receipts</v-btn>
                <v-btn text v-if="orderDetail.o_is_hpc" color="warning" :to="{ name: 'hpcOrders' }" class="ma-0 mb-2"><v-icon left>arrow_back</v-icon> All Receipts</v-btn>

                <v-overlay :absolute="true" :value="overlay" z-index="99" opacity="0.56">
                    <v-card>
                        <v-card-text v-html="overlayText"></v-card-text>
                        <v-card-actions>
                            <v-btn medium block dark :color="overlayColor" @click="overlay = false">Close <v-icon medium right>highlight_off</v-icon> </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-overlay>

                <div v-if="orderLoaded && viewOrder" v-cloak>
                    <h1 class="grey--text lighten-3 mb-2">
                        <span v-if="orderDetail.o_payments && orderDetail.o_payments.length > 0 && !orderDetail.o_invoice">Receipt #{{ orderDetail.o_payments[0].p_id }}</span>
                        <span v-else-if="orderDetail.o_invoice">Invoice #{{ orderDetail.o_invoice_id }}</span> <span v-else>Receipt #{{ orderDetail.o_id }}</span>
                    </h1>

                    <v-toolbar color="secondary" dark>
                        <v-toolbar-title>{{ user.fullname }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            v-if="orderDetail.o_payments && orderDetail.o_payments.length > 0"
                            :disabled="receiptLoading"
                            :loading="receiptLoading"
                            @click="sendReceipt(orderDetail.o_id)"
                            >Re-send Receipt<v-icon right>send</v-icon></v-btn
                        >
                    </v-toolbar>

                    <v-card>
                        <v-container container--fluid grid-list-lg class="pa-0">
                            <v-layout row wrap class="pa-2 ma-0">
                                <v-flex xs12>
                                    <v-card color="blue-grey darken-2" class="white--text">
                                        <v-card-title primary-title>
                                            <div>
                                                <div class="headline"><v-icon medium left color="white">shopping_basket</v-icon>Order Information</div>
                                            </div>
                                        </v-card-title>

                                        <div class="Ftable black--text">
                                            <div class="Ftable__row Ftable__header">
                                                <div class="Ftable__item cols-3 text-left">Date</div>
                                            </div>
                                            <div class="Ftable__row">
                                                <div class="Ftable__item text-left bottom-border">
                                                    <span>{{ moment(orderDetail.o_date).format("DD/MM/YYYY hh:mm a") }}</span>
                                                </div>
                                                <div class="Ftable__item text-left no-border top-border bottom-border">&nbsp;</div>
                                                <div class="Ftable__item text-left no-border top-border bottom-border">&nbsp;</div>
                                            </div>
                                            <div class="Ftable__row Ftable__header">
                                                <div class="Ftable__item cols-2 text-left">Product Name</div>
                                                <div class="Ftable__item text-right">Quantity</div>
                                                <div class="Ftable__item text-right">Price</div>
                                            </div>
                                            <div class="d-block" style="width: 100%;" v-for="product in orderDetail.o_products" :key="product.pid">
                                                <div class="Ftable__row">
                                                    <div class="Ftable__item cols-2 text-left bottom-border">
                                                        <span>{{ product.opr_name }}</span>
                                                    </div>
                                                    <div class="Ftable__item text-right">
                                                        <span>{{ product.opr_quantity }}</span>
                                                    </div>
                                                    <div class="Ftable__item text-right">
                                                        <span>{{ product.opr_total | currency }}</span>
                                                    </div>
                                                </div>
                                                <div class="Ftable__row" v-if="product.attendees">
                                                    <div class="Ftable__item text-left bottom-border">
                                                        <b><v-icon color="black" small left style="vertical-align: text-top;">person</v-icon>Attendees:</b>
                                                        <span>{{ product.attendees }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="Ftable__row">
                                                <div class="Ftable__item text-left no-border top-border bottom-border">&nbsp;</div>
                                            </div>
                                            <div class="Ftable__row">
                                                <div class="Ftable__item no-border cols-2 right-border top-border"></div>
                                                <div class="Ftable__item text-right">
                                                    <span><strong>Subtotal</strong></span>
                                                </div>
                                                <div class="Ftable__item text-right">
                                                    <span>{{ Math.abs(orderDetail.o_subtotal) | currency }}</span>
                                                </div>
                                            </div>
                                            <div class="Ftable__row" v-if="showTax(orderDetail.o_products)">
                                                <div class="Ftable__item no-border cols-2 right-border"></div>
                                                <div class="Ftable__item text-right">
                                                    <span><strong>Tax</strong></span>
                                                </div>
                                                <div class="Ftable__item text-right">
                                                    <span>{{ Math.abs(orderDetail.o_tax) | currency }}</span>
                                                </div>
                                            </div>
                                            <div class="Ftable__row">
                                                <div class="Ftable__item no-border cols-2 right-border"></div>
                                                <div class="Ftable__item text-right">
                                                    <span><strong>Total</strong></span>
                                                </div>
                                                <div class="Ftable__item text-right">
                                                    <span>{{ Math.abs(orderDetail.o_total) | currency }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12 v-if="orderDetail.o_booking">
                                    <v-card color="blue-grey darken-2" class="white--text">
                                        <v-card-title primary-title>
                                            <div>
                                                <div class="headline"><v-icon medium left color="white">event</v-icon>Booking Information</div>
                                            </div>
                                        </v-card-title>

                                        <div class="Ftable black--text" v-if="orderDetail.o_bookings && orderDetail.o_bookings.length > 0">
                                            <div class="Ftable__row Ftable__header">
                                                <div class="Ftable__item cols-25 text-left">Date / Time</div>
                                                <div class="Ftable__item cols-15 text-left">Venue</div>
                                                <div class="Ftable__item cols-15 text-left">Sport</div>
                                                <div class="Ftable__item cols-15 text-left">Court</div>
                                                <div class="Ftable__item cols-15 text-left">Type</div>
                                                <div class="Ftable__item cols-15 text-left">Option</div>
                                            </div>
                                            <template v-for="booking in orderDetail.o_bookings">
                                                <div class="Ftable__row" :key="booking.b_id">
                                                    <div class="Ftable__item cols-25 text-left bottom-border">
                                                        <span><b>From:</b> {{ moment(booking.b_from).format("DD/MM/YYYY hh:mm a") }}</span><br>
                                                        <span><b>To:</b> {{ moment(booking.b_to).format("DD/MM/YYYY hh:mm a") }}</span>
                                                    </div>
                                                    <div class="Ftable__item cols-15 text-left bottom-border">
                                                        <span>{{booking.b_venue}}</span>
                                                    </div>
                                                    <div class="Ftable__item cols-15 text-left bottom-border">
                                                        <span>{{booking.b_sport}}</span>
                                                    </div>
                                                    <div class="Ftable__item cols-15 text-left bottom-border">
                                                        <span>{{booking.b_space}}</span>
                                                    </div>
                                                    <div class="Ftable__item cols-15 text-left bottom-border">
                                                        <span>{{booking.b_type}}</span>
                                                    </div>
                                                    <div class="Ftable__item cols-15 text-left bottom-border">
                                                        <span>{{booking.b_option}}</span>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12>
                                    <v-card color="blue-grey darken-2" class="white--text">
                                        <v-card-title primary-title>
                                            <div>
                                                <div class="headline"><v-icon medium left color="white">attach_money</v-icon>Payment Information</div>
                                            </div>
                                        </v-card-title>

                                        <div class="Ftable black--text" v-if="orderDetail.o_payments && orderDetail.o_payments.length > 0">
                                            <div class="Ftable__row Ftable__header">
                                                <div class="Ftable__item text-left">Date</div>
                                                <div class="Ftable__item text-left">Method</div>
                                                <div class="Ftable__item text-left">Member</div>
                                                <div class="Ftable__item text-right">Amount</div>
                                            </div>
                                            <template v-for="payment in orderDetail.o_payments">
                                                <div class="Ftable__row" :key="payment.p_id">
                                                    <div class="Ftable__item text-left bottom-border">
                                                        <span>{{ moment(payment.p_date).format("DD/MM/YYYY hh:mm a") }}</span>
                                                    </div>
                                                    <div class="Ftable__item text-left">
                                                        <span
                                                            >{{ payment.p_origin | capitalize }}
                                                            <span v-if="payment.p_origin == 'Front Desk' && !payment.p_refunded && payment.p_amount < 0">(Payout)</span>
                                                        </span>
                                                    </div>
                                                    <div class="Ftable__item text-left">
                                                        <div>{{ payment.p_member | capitalize }}</div>
                                                    </div>
                                                    <div class="Ftable__item text-right">
                                                        <span>{{ displayAmount(payment) | currency }}</span>
                                                    </div>
                                                </div>
                                                <div class="Ftable__row" v-if="payment.p_discount > 0" :key="payment.p_id + '-discount'">
                                                    <div class="Ftable__item text-left bottom-border">
                                                        <span>{{ moment(payment.p_date).format("DD/MM/YYYY hh:mm a") }}</span>
                                                    </div>
                                                    <div class="Ftable__item text-left">
                                                        <span>{{ payment.p_discount_orig | capitalize }}</span>
                                                    </div>
                                                    <div class="Ftable__item text-left">
                                                        <div>{{ payment.p_member | capitalize }}</div>
                                                    </div>
                                                    <div class="Ftable__item text-right">
                                                        <span>{{ payment.p_discount | currency }}</span>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </v-card>
                                </v-flex>
                                <v-flex class="text-right" v-if="orderDetail.o_invoice && !orderDetail.o_is_hpc">
                                    <div>
                                        <b>Amount outstanding:</b>
                                        <span class="px-2" style="color: #f7941b;"
                                            ><b>{{ owingPayments(orderDetail.o_total, orderDetail.o_payments) }}</b></span
                                        >
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </div>

                <div class="justify-center align-center layout" v-if="!orderLoaded && !viewOrder" v-cloak><v-icon left medium>warning</v-icon>No Receipt Data"</div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "./_store";
import moment from "moment";

export default {
    name: "OrderDetailModule",
    components: {
        //
    },
    props: {
        "order-oid": {
            type: [Number, String],
            required: true,
        },
        "typeorig":{
           type: [String],
        }
    },
    data() {
        return {
            orderDetail: {},
            orderLoaded: false,
            viewOrder: true,
            moment: moment,
            overlay: false,
            timeout: 3500,
            overlayText: "",
            overlayColor: "cyan darken-2",
        };
    },
    computed: {
        user() {
            return this.$store.getters["user/getProfile"];
        },
        orders() {
            return this.$store.getters["order/orders"];
        },
        order() {
            return this.$store.getters["order/orderDetailById"](this.orderOid);
        },
        receiptLoading() {
            return this.$store.getters["order/orderStatus"] == "loading";
        },
    },
    watch: {
        orders(n, o) {
            let orderId = this.orderOid;
            this.orderDetail = _.find(n, function(ord) {
                return ord.o_id == orderId;
            });
            // console.log(this.orderDetail.o_payments.length);

            if (_.isEmpty(this.orderDetail) && this.order === undefined) {
                this.orderLoaded = false;
                this.viewOrder = false;
            }
        },
        order() {
            this.orderDetail = this.order;
        },
    },
    methods: {
        total(payments) {
            let sum = parseFloat(0.0);
            return payments.reduce(function(sum, payment) {
                let discount = !_.isNil(payment.p_discount) ? payment.p_discount : 0.0;
                let amount = payment.p_amount;

                if (payment.p_refunded) {
                    amount = payment.p_amount * -1;
                }

                return sum + parseFloat(amount) + parseFloat(discount);
            }, 0.0);
        },
        owingPayments(total, payments) {
            let sum = !_.isEmpty(payments) ? this.total(payments) : 0;

            let owing = parseFloat(parseFloat(total) - parseFloat(sum)).toFixed(2);
            return this.$options.filters.currency(owing);
        },
        showTax(products) {
            return !_.every(products, ["opr_payout", true]);
        },
        displayAmount(payment) {
            return payment.p_refunded ? payment.p_amount * -1 : Math.abs(payment.p_amount);
        },
        sendReceipt(order_id) {
            this.$store
                .dispatch("order/orderReceipt", { orderId: order_id })
                .then(resp => {
                    // console.log(resp);
                    this.overlayColor = "primary";
                    this.overlayText = resp;
                    this.overlay = true;
                })
                .catch(err => {
                    // console.log(err);
                    this.overlayColor = "error";
                    this.overlayText = err;
                    this.overlay = true;
                });
        },
    },
    beforeCreate() {
        // this.$store.dispatch('user/userRequest');
        // if(_.isEmpty(this.$store.getters['order/orders'])){
            this.$store.dispatch("order/orderDetailRequest", { 'orderId': this.$options.propsData.orderOid }).catch(err => {
                // console.log(err);
                this.overlayColor = "error";
                this.overlayText = err;
                this.overlay = true;
            });
        // }
    },
    mounted() {
        if (_.isEmpty(this.orderDetail) && this.order !== undefined) {
            this.orderDetail = this.order;
        }

        this.orderLoaded = true;
    },
};
</script>

<style lang="scss" scoped>
[v-cloak] {
    display: none;
}
[v-cloak] > * {
    display: none;
}

.Ftable {
    $light-color: #ffffff;
    $header-color: #f8c689;
    $dark-color: #f2f2f2;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /*border: 1px solid $dark-color;*/
    font-size: 1rem;
    padding: 0;
    margin: 0;
    line-height: 1.5;

    .Ftable__row {
        width: 100%;
        display: flex;

        &.Ftable__header {
            font-weight: bold;

            .Ftable__item {
                background: $header-color;
            }
        }

        .Ftable__item {
            flex: 1 1 25%;
            word-break: break-word;
            padding: 0.25em;
            border: 1px solid $light-color;
            background: $dark-color;

            &.cols-2 {
                flex: 1 1 50%;
            }

            &.cols-25 {
                flex: 1 1 25%;
            }

            &.cols-15 {
                flex: 1 1 15%;
            }

            &.no-border {
                border: 0px solid $light-color;
            }

            &.right-border {
                border-right: 1px solid $light-color;
            }

            &.top-border {
                border-top: 1px solid $light-color;
            }

            &.bottom-border {
                border-bottom: 1px solid $light-color;
            }
        }
    }
}
</style>
